import styled from 'styled-components';

export const PillButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0 12px;
    height: 24px;
    width: auto;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    background-color: ${({ theme }) => theme.colors.pillbutton.surface};
    
    font-family: 'Elza', sans-serif;
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
    text-align: left;
    color: ${({ theme }) => theme.colors.pillbutton.text};

    &:hover {
        background-color: ${({ theme }) => theme.colors.pillbutton.surface};
    }
`;

export const SmallButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 0;
    padding: 0 12px;
    height: 24px;
    width: auto;
    border-radius: 8px;
    
    font-family: 'Elza', sans-serif;
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
    text-align: left;


    background-color: ${({ theme }) => theme.colors.button.surface.primary};
    color: ${({ theme }) => theme.colors.button.text.primary};
    border: none;

    &:hover {
        background-color: ${({ theme }) => theme.colors.button.surface.primary};
    }
`;

const hexToRgb = (hex: string) => {
  hex = hex.replace(/^#/, '');

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `${r}, ${g}, ${b}`;
};

export const PillButtonColorTheme = styled(PillButton)`
    background-color: ${({ theme }) => `rgba(${hexToRgb(theme.colors.button.surface.primary)}, 0.2)`};
    color: ${({ theme }) => theme.colors.button.text.secondary};
    border: none;
    gap: 4px;

    &:hover {
        background-color: ${({ theme }) => `rgba(${hexToRgb(theme.colors.button.surface.primary)}, 0.2)`};
    }
`;

export const BigButton = styled.button`
    width: 100%;
    height: 40px;
    padding: 8px 16px;
    border-radius: 8px;
    opacity: 0px;

    font-family: 'Elza', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    text-align: center;

    color: ${({ theme }) => theme.colors.button.text.primary};
`;

export const BigButtonOutlined = styled(BigButton)`
    width: 100%;
    height: 40px;
    padding: 8px 16px;
    border-radius: 8px;
    opacity: 0px;
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.border};
    color: ${({ theme }) => theme.colors.text.primary};

    font-family: 'Elza', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    text-align: center;

    &:hover {
        background-color: transparent;
    }
`;

